import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FuseFullscreenModule } from '@fuse/components/fullscreen';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { LanguagesModule } from 'app/layout/common/languages/languages.module';
import { UserModule } from 'app/layout/common/user/user.module';
import { ClassicLayoutComponent } from 'app/layout/layouts/vertical/classic/classic.component';
import { DarkModuleSwitcherModule } from 'app/shared-components/dark-mode-switcher/dark-module-switcher.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ClassicLayoutComponent],
  imports: [
    HttpClientModule,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    FuseFullscreenModule,
    FuseNavigationModule,
    LanguagesModule,
    UserModule,
    DarkModuleSwitcherModule,
    CommonModule,
  ],
  exports: [ClassicLayoutComponent],
})
export class ClassicLayoutModule {}
